<template>

<v-layout justify-center>
  
  <v-flex xs12 sm12 md12 lg12 class="mt-12">
      <v-card flat color="background">

        <v-container fluid grid-list-lg>
          
          <transactions-toolbar 
            title="Transacciones" 
            placeholderSearch="Buscar" 
            @searchItem="searchItemData" 
            @filterChanged="filterWasChanged"
            :date="date"
            :dateEnd="dateEnd"
            :business="activeBusiness" />

          <v-layout row wrap white>
            <span style="margin: 20px;">Desde: </span>
            <div style="width: 250px; margin-left: 15px;">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedDateFormattedMomentjs"
                    readonly
                    persistent-hint
                    v-bind="attrs"
                    v-on="on" />
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  color="primary"
                  @change="dateSelected"
                  @input="menu1 = false">
                </v-date-picker>
              </v-menu>
            </div>
            <span style="margin: 20px;">Hasta: </span>
<div style="width: 250px; margin-left: 15px;">
        <v-menu
          ref="showDPE"
          v-model="showDPE"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dateFormattedEnd"
              readonly
              class="input-datapicker-table"
              persistent-hint
              v-bind="attrs"
              v-on="on"/>
          </template>
          <v-date-picker
            v-model="dateEnd"
            no-title
            color="primary"
            @change="dateSelected"
            @input="showDPE = false"/>
        </v-menu>
      </div>


            <v-flex lg12 md12 xl12 sm12>
              <v-data-table
                  :headers="headers"
                  :items="transactions"
                  :items-per-page="10"
                  item-key="transaction_id"
                  sort-by="transaction_id"
                  group-by="tag_id"
                  show-group-by
                  @click:row="rowClicked">

                  <template #item="{ item }">
                    <tr>
                      <td>{{ formattedDate(item.createdAt) }}</td>
                      <td>{{ item.transaction_id }}</td>
                      <td>{{ item.transaction_type.name }}</td>
                      <td>{{ item.payment_method.name }}</td>
                      <td>
                        <span :style="item.amount < 0 ? 'color:red;' : ''">
                          {{ item.amount < 0 ? '-' : ''}} {{  formatCurrency(item.amount) }}
                        </span>
                      </td>
                      <td>
                        <span :style="item.tag_balance < 0 ? 'color:red;' : ''">
                           {{ item.transaction_type.name == "Recarga" 
                          ? formatCurrency(item.amount + item.tag_balance) 
                          : formatCurrency(item.tag_balance - item.amount) }}
                        </span>
                      </td>
                      <td>{{ item.status == 1 ? 'Realizado' : 'Cancelado' }}</td>
                    </tr>
                  </template>

                </v-data-table>
            </v-flex>
          </v-layout>

          <confirm-modal ref="confirm" @interface="componentConfirmResult" />
          <transaction-info-drawer ref="drawerTransaction"/>

        </v-container>
      </v-card>
    </v-flex>
  </v-layout>   
</template>
<script>
  import axios from 'axios';
  import TransactionsToolbar from './Toolbars/TransactionsToolbar'
  import ConfirmModal from './Dialogs/ConfirmModal'
  import TransactionInfoDrawer from './Drawers/TransactionInfoDrawer'
  import NoResults from './NoResults'
  import moment from 'moment'
  import { format, parseISO } from 'date-fns'

  const REQUEST_ITEM_DELETE = 1;
  const REQUEST_ITEM_TOGGLE_ACTIVATE = 2;

  export default {
    components: {
      TransactionsToolbar,
      ConfirmModal,
      TransactionInfoDrawer,
      NoResults
    },
    data: (vm) => ({
      date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      menu1: false,
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      showDPE: false,

     
      filterSelected: '', //Todos los items
      methodType: 'all',
      operationType: 'all',
      collaborators: [],
      terminals: [],
      currentSearch: '',
      publicPath: process.env.VUE_APP_URL,
      headers: [
          {
            text: 'Creado',
            align: 'start',
            value: 'createdAt',
            groupable: false,
          },
          { text: 'Transacción', value: 'transaction_id', groupable: false},
          { text: 'Tag', value: 'tag_id' },
          { text: 'Operación', value: 'transaction_type', groupable: false },
          { text: 'Método', value: 'payment_method', groupable: false },
          { text: 'Monto', value: 'amount', groupable: false },
          { text: 'Saldo', value: 'tag_balance', groupable: false },
          { text: 'Estatus', value: 'status', groupable: false },
        ],
        transactions: [],
    }),

    created () {
      this.initialize();
      this.loadListeners();
    },

    mounted() {
      //this.$store.dispatch('savePath', 'transactions');
      this.$bus.$emit('selectCurrentMenuOption',1);
    },
    computed: {
      computedDateFormattedMomentjs () {
        return this.date ? this.dateHelpers.formatInput(this.date) : ''
      },
      dateFormattedEnd () {
        return this.dateEnd ? this.dateHelpers.formatInput(this.dateEnd) : ''
      },
      activeBusiness(){
        return this.$store.getters.business;
      },
    },
    methods: {
      formatCurrency(amount) {
        if (isNaN(amount)) return amount;
        return new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      },
      rowClicked(row){
        console.log(row);
        this.showItemInfo(row);
      },
      formattedDate(date){
        //const fDate = moment(date).utcOffset(0).format('DD MMMM YYYY HH:mm:ss');
        const fDate = this.dateHelpers.formatTable(date)
        return fDate;
      },
      dateSelected(date){
        this.listTransactions();
      },
      viewBusiness(business){
        this.$store.dispatch('saveBusiness', business)
      },
      filterWasChanged(filterSelected,filterValue){
        console.log(filterSelected);
        console.log(filterValue);
        if(filterSelected == 'operationFilter'){
          this.operationType = filterValue;
        }else{
          this.methodType = filterValue;
        }
        //this.filterSelected = selectedFilter;
        this.listTransactions();
      },
        loadListeners () {
              this.$bus.$off('refreshCollaboratorsList');

              this.$bus.$on('refreshCollaboratorsList', (isLoading) => {
                //this.listCollaborators();
              });
        },
        showItemInfo(item){
          this.$refs.drawerTransaction.show(item);
        },
        deleteItemConfirmed(item_id, isConfirmated){
          if(isConfirmated){
            this.$bus.$emit('toggleLoading', true);
            axios.post('collaborators/delete',{item_id}).then(response => {
                this.$bus.$emit('toggleLoading', false);
                //this.listCollaborators();
            }).catch(err => {

            });
          }
        },
        toggleActivationItemConfirmed(item_id, isConfirmated){
          if(isConfirmated){
            this.$bus.$emit('toggleLoading', true);
            axios.patch('collaborators/toggleActivation',{item_id}).then(response => {
                this.$bus.$emit('toggleLoading', false);
                //this.listCollaborators();
            }).catch(err => {

            });
          }
        },
        componentConfirmResult(isConfirmated, item_id, component){
          switch (component) {
                case REQUEST_ITEM_DELETE :
                  this.deleteItemConfirmed(item_id, isConfirmated);
                break;
                case REQUEST_ITEM_TOGGLE_ACTIVATE :
                  this.toggleActivationItemConfirmed(item_id, isConfirmated);
                break;
            }
        },
        editItem(item){
          const itemRow = {...item};
          this.$refs.addEditModal.edit(itemRow);
        },
        deleteItem(item){
          let data = {
              title: "Eliminar",
              message: `¿Deseas eliminar a <<b>${item.name}</b>>? No podrás deshacer la acción.`,
              confirmText: "Si, Eliminar"
          }
          this.$refs.confirm.open(data, REQUEST_ITEM_DELETE, item._id);
        },
        toggleActivationItem(item){
          const message = item.status ? `<<b>${item.name}</b>> no podrá ingresar a la aplicación móvil. ¿Deseas continuar?`
          : `<<b>${item.name}</b>> podrá usar nuevamente la aplicación. ¿Deseas continuar?`;
          let data = {
              title: item.status ? "Bloquear colaborador" : "Reactivar colaborador",
              message: message,
              confirmText: item.status ? "Si, Bloquear" : "Si, Reactivar"
          }
          this.$refs.confirm.open(data, REQUEST_ITEM_TOGGLE_ACTIVATE, item._id);
        },
        addNewCollaborator(){
          this.$refs.addEditModal.open();
        },
        searchItemData(search){
          this.currentSearch = search;
          this.listTransactions();
        },
        listTransactions(){
          let me=this;
          const userData = this.$store.state.user
          const search = this.currentSearch;
          this.$bus.$emit('toggleLoading', true);

          if(userData.role == "admin"){

            axios.get('users/query?_id='+userData._id)
            .then(function (responseUser){
              console.log("XXX")
              console.log(responseUser.data.business)
              const businessId = responseUser.data.business ;
              axios.get(`transactions/list/${businessId}/${me.operationType}/${me.methodType}?search=${search}&date=${me.date}&dateEnd=${me.dateEnd}`).then(response => {
                me.transactions = response.data;
                me.$bus.$emit('toggleLoading', false);
              }).catch(err => {});

            })

          }else{
            const businessId = this.activeBusiness._id ;
            axios.get(`transactions/list/${businessId}/${this.operationType}/${this.methodType}?search=${search}&date=${this.date}&dateEnd=${me.dateEnd}`).then(response => {
              this.transactions = response.data;
              this.$bus.$emit('toggleLoading', false);
            }).catch(err => {});
          }
           

            
           
            
        },
        initialize () {
            this.listTransactions();
        },
    },
  }
</script>
<style scoped>
 .flex-empty div {
  width: 350px;
}
.card-item{
  min-width: 320px !important;
  /*flex-basis: initial !important;
  max-width: initial !important;*/
}
#card-container, .data-containe{
  height: 55vh;
  overflow: auto;
  width: 100%;
  padding-right: 0 !important;
  margin-right: 0 !important;
}
 .v-list-item__action{
  margin-left: 0 !important;
}
.item-title:hover{
  text-decoration: underline;
}

</style>